<page-context [page]="this">
  <div class="newsletter-container">
      <div>
          <div class="image-container">
              <div (click)="selectNewsletter('newsletter')" class="image-item" [ngClass]="newsletterTypes['newsletter'] ? 'selected' : 'image'">
                <div class="image newsletter"></div>

                <div class="text-container">
                  <h4 class="title">Daily Newsletter</h4>
                  <p class="description">
                      Get your daily dose of TYT with up-to-the-minute exclusive articles, post show analysis and happenings on the network!
                  </p>
                </div>

                <div class="checkbox-container">
                  <div class="checkbox"></div>
                </div>
              </div>
          </div>

          <div class="image-container">
            <div (click)="selectNewsletter('newsletter_weekly')" class="image-item" [ngClass]="newsletterTypes['newsletter_weekly'] ? 'selected' : 'image'">
              <div class="image newsletter_weekly"></div>

              <div class="text-container">
                <h4 class="title">Weekly Newsletter</h4>
                <p class="description">
                  See what you missed with a weekly recap of TYT shows and invesigative reporting. You’ll also get updates on town halls and special events!
                </p>
              </div>

              <div class="checkbox-container">
                <div class="checkbox"></div>
              </div>
            </div>
          </div>

          <div class="image-container">
            <div (click)="selectNewsletter('army')" class="image-item" [ngClass]="newsletterTypes['army'] ? 'selected' : 'image'">
              <div class="image army"></div>

              <div class="text-container">
                <h4 class="title">Army Newsletter</h4>
                <p class="description">
                  Join the Growing list of volunteers and fighting to abolish propaganda and return our government and media to we the people!
                </p>
              </div>

              <div class="checkbox-container">
                <div class="checkbox"></div>
              </div>
            </div>
          </div>

          <div class="image-container">
            <div (click)="selectNewsletter('shop')" class="image-item" [ngClass]="newsletterTypes['shop'] ? 'selected' : 'image'">
              <div class="image shop"></div>

              <div class="text-container">
                <h4 class="title">Shop Newsletter</h4>
                <p class="description">
                  Check out the latest merchandise and special limited time offers in Shop TYT so you may proudly wear your support!
                </p>
              </div>

              <div class="checkbox-container">
                <div class="checkbox"></div>
              </div>
            </div>
          </div>

          <div class="image-container">
            <div (click)="selectNewsletter('news_and_alerts')" class="image-item" [ngClass]="newsletterTypes['news_and_alerts'] ? 'selected' : 'image'">
              <div class="image news_alerts"></div>

              <div class="text-container">
                <h4 class="title">News and Alerts</h4>
                <p class="description">
                  Get your daily dose of TYT with up-to-the-minute exclusive articles, post show analysis and happenings on the network!
                </p>
              </div>

              <div class="checkbox-container">
                <div class="checkbox"></div>
              </div>
            </div>
          </div>

          <form (submit)="signUp()">
              <ng-container *ngIf="!submitted">
                  <p class="call-to-action">Select a newsletter & enter your email</p>
                  <p *ngIf="errorText" class="error">{{ errorText }}</p>
                  <div class="form-group">
                      <input errorHighlight type="text" name="email" class="form-control" placeholder="Your email" [(ngModel)]="email">
                  </div>
                  <button type="submit" class="sign-up-btn">
                    Sign Me Up!
                    <img src="/assets/yellow-arrow-right.svg" alt="">
                  </button>

              </ng-container>
              <ng-container *ngIf="submitted">
                  <h1>THANK YOU!</h1>
                  <p>The selected newsletters will be sent to: <br/> {{ email }}</p>
              </ng-container>
          </form>
      </div>
      <!-- <a target="_blank" href="http://the-young-turks.myklpages.com/p/newsletters">View all our newsletters</a> -->
  </div>
</page-context>